<template>
  <BaseFollowupRuleDialog
    :name="name"
    :dialog.sync="_dialog"
    :rule-holder-id="groupId"
    :show-details="showDetails"
    :query-rule-gql="queryRuleGql"
    :create-rule-gql="createRuleGql"
    :update-rule-gql="updateRuleGql"
    :get-query-variables="getQueryVariables"
    :is-rule-enabled="isRuleEnabled"
    :set-rule-enabled="setRuleEnabled"
    :default-rule-data="defaultRuleData"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseFollowupRuleDialog from './BaseFollowupRuleDialog'
import { LIST_GROUP_RULES, UPDATE_GROUP_RULE, CREATE_GROUP_RULE } from '@/backend/graphql/automationGQL'
import moment from 'moment-timezone'
import _ from 'lodash'
export default {
  name: 'GroupFollowupRuleDialog',
  components: { BaseFollowupRuleDialog },
  props: {
    name: {
      type: String,
      default: ''
    },
    dialog: {
      type: Boolean,
      default: false
    },
    showDetails: {
      type: Boolean,
      default: true
    },
    groupId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      queryRuleGql: LIST_GROUP_RULES,
      updateRuleGql: UPDATE_GROUP_RULE,
      createRuleGql: CREATE_GROUP_RULE,
      defaultRuleData: {
        name: '',
        groupId: this.groupId,
        ruleType: 'STAY_IN_CONTACT',
        enabled: true,
        repeated: true,
        applyToNew: false,
        frequency: 1,
        skipContactedWithin: 0,
        applyToBirthday: true,
        applyToAll: false,
        eventDate: moment().format('YYYY-MM-DD'),
        remindDays: -1,
        scheduleTime: '08:00 am',
        timeZone: moment.tz.guess(),
        ruleMessage: [{ body: '' }]
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'account/getUser',
      allRules: 'automation/getAllRules'
    }),
    _dialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('update:dialog', val)
      }
    }
  },
  methods: {
    ...mapActions({
      updateGroupRuleByIndex: 'automation/updateGroupRuleByIndex'
    }),
    getQueryVariables () {
      return {
        limit: 50,
        offset: 0,
        orderBy: '-id,name',
        userIds: [_.get(this.user, 'id', 0)],
        groupId: this.groupId
      }
    },
    isRuleEnabled (index) {
      const group = _.get(this.allRules, `[${index}].group`, [])
      return group.filter((g) => Number(g.id) === Number(this.groupId)).length > 0
    },
    setRuleEnabled (index) {
      this.updateGroupRuleByIndex({ index, groupId: this.groupId })
    }
  }
}
</script>

<style scoped>

</style>
